import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AgeRequirementService } from '~/core/services/activity/age-requirement.service';

/*
 * Displays the age of the participant if he or she is a minor, or "Adult"
 * Usage:
 *   ageOfAttendee | displayAge
 * Example:
 *   {{ 18 | displayAge }}
 *   formats to: Adulte
 *   {{ 7 | displayAge }}
 *   formats to: 7 ans
 */
@Pipe({ name: 'displayAge' })
export class DisplayAgePipe implements PipeTransform {
  constructor(
    private readonly translateService: TranslateService,
    private readonly ageRequirement: AgeRequirementService
  ) {}

  public transform(age: number): string {
    const majority = +this.ageRequirement.tenantMajority;

    if (age < majority) {
      return this.translateService.instant(
        'organizer.participant_list.booking.attendee.age',
        { age }
      );
    }

    return this.translateService.instant(
      'organizer.participant_list.booking.attendee.adult'
    );
  }
}
